<template>
  <div class="h5">
    <el-button type="primary" @click="login">微信登录</el-button>
    <div> code : {{code}}</div>
    <div v-html="content" style="white-space: pre-wrap"></div>
  </div>
</template>

<script>
export default {
  // wxe885c80324c6dfaa
  data() {
    return {
      code: '',
      content: '参与活动前请仔细阅读活动规则:\n\n1.活动时间：2022年12月9日16:30-2023年1月3日23:59;\n\n2.活动期间用户充值活动套餐可获得相应抽奖机会，100%中奖！\n\n3.抽奖奖品随机获得，不可进行退换！\n\n4.获得时长卡或优惠券的用户，奖品将直接发送至抽奖账户卡券包，请“登录客户端-卡券包-使用卡券”领取。活动卡券有效期为“获取后7日内”，过期未使用的卡券将作废。\n\n5.获得键盘/耳机/免单券的用户，请添加客服QQ：3573609523，提供中奖截图领奖。请在 2023年1月5日 18 : 00 之前进行兑奖，过期将自动失效。\n\n6.活动页面抽奖机会仅限在活动期间使用，逾期清空作废！\n\n7.新人年卡/新人半年卡/新人季卡不参与本次抽奖活动，若需参与活动请直接在本活动页购买活动套餐并参与抽奖。\n\n\n本次活动的最终解释权归深圳市羿日科技有限公司所有'
    }
  },
  created(){
    // code=CODE&state=STATE。
    const { code } = this.$route.query
    this.code = code
    
  },
  methods: {
    login(){
      const redirect_uri = encodeURIComponent('https://js.3dmjiasu.com/wechatH5')
      const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe885c80324c6dfaa&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo#wechat_redirect`
      window.open(url)
    }
  }
}
</script>

<style>
.h5{
  color: #fff;
}
</style>